import React, { useState, useEffect, useMemo } from 'react'
import { Link } from 'react-router-dom'
import redBallLogo from '../../media/red-ball.png'

const SERIES_ROUTE_MAP = {
  12: '12/123',
  6: '6/67',
  1: '1/10',
  11: '11/115',
  10: '10/105',
  7: '7/93',
  5: '5/59',
  2: '2/32',
  22: '22/208',
  24: '24/220'
}

export default function ANCLSeries() {
  const [value, setValue] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const ctrl = new AbortController()

    ;(async () => {
      try {
        setLoading(true)
        setError(null)

        const res = await fetch(
          'https://core-prod-origin.cricclubs.com/core/series/getSeriesList?X-Auth-Token=&clubId=16685&limit=10',
          {
            method: 'GET',
            headers: {
              Accept: 'application/json',
              'x-consumer-key': 'ACN$2025^%',
              'x-api-key': 'NaT^0708'
            },
            signal: ctrl.signal
          }
        )

        if (!res.ok) {
          throw new Error(`HTTP ${res.status} ${res.statusText}`)
        }

        const data = await res.json()
        setValue(data)
      } catch (err) {
        if (err.name !== 'AbortError') {
          setError(err.message || 'Unknown error')
          setValue(null)
        }
      } finally {
        setLoading(false)
      }
    })()

    return () => ctrl.abort()
  }, [])

  const series = useMemo(() => {
    const raw = value?.data?.seriesList ?? []
    const arr = Array.isArray(raw) ? raw : Object.values(raw)
    return arr.filter(Boolean).map(s => ({
      id: Number(s.seriesID),
      name: s.seriesName,
      type: s.seriesType,
      year: s.year
    }))
  }, [value])

  return (
    <>
      <div className='container my-5'>
        <div className='top-heading m-auto'>
          <img src={redBallLogo} alt='Red ball' />
          <span> SERIES </span>
        </div>
        <h1 className='text-center mb-4'>
          <strong>ANCL Series Maverickscc Played</strong>
        </h1>

        <div className='row'>
          {loading && (
            <div className='d-flex justify-content-center w-100 my-4'>
              <div className='spinner-border' role='status' aria-label='loading' />
            </div>
          )}

          {error && (
            <div className='alert alert-danger w-100' role='alert'>
              There is a problem fetching the data — {error}
            </div>
          )}

          {!loading && !error && series.length === 0 && (
            <div className='w-100 text-center text-muted my-4'>No series found.</div>
          )}

          {!loading &&
            !error &&
            series.map((s, idx) => {
              const route = SERIES_ROUTE_MAP[s.id]
              const Card = (
                <div className='series-box'>
                  <h3>{s.name}</h3>
                  <p>
                    <strong>Series Type: </strong>
                    {s.type || '-'}
                  </p>
                  <p>
                    <strong>Year: </strong>
                    {s.year || '-'}
                  </p>
                  <span>{idx + 1}</span>
                </div>
              )

              return (
                <div className='col-lg-6 my-3' key={`${s.id}-${idx}`}>
                  {route ? <Link to={`/anclresult/${route}`}>{Card}</Link> : Card}
                </div>
              )
            })}
        </div>
      </div>
    </>
  )
}
